/**
 * OfflineFeatureGate
 *
 * Wraps UI that requires network connectivity.
 * When offline, shows a compact message instead of the child UI.
 *
 * Usage:
 *   <OfflineFeatureGate feature="Deliveries">
 *     <DeliveryForm />
 *   </OfflineFeatureGate>
 */
import React from 'react';
import { WifiOff } from 'lucide-react';

export default function OfflineFeatureGate({ children, feature, className = '' }) {
  const isOnline = navigator.onLine;

  if (isOnline) return children;

  return (
    <div
      className={`flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-700 ${className}`}
      data-testid={`offline-gate-${(feature || 'unknown').toLowerCase().replace(/\s+/g, '-')}`}
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>
        <strong>{feature || 'This feature'}</strong> requires an internet connection.
        Reconnect to use this feature.
      </span>
    </div>
  );
}
